// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_LANGUAGE_LIST = 'language/SET_LANGUAGE_LIST';
export const APPEND_LANGUAGES = 'language/APPEND_LANGUAGES';
export const UPDATE_LANGUAGE_ITEM = 'language/UPDATE_LANGUAGE_ITEM';
export const CLEAR_DEFAULT = 'language/CLEAR_DEFAULT';

